import * as Yup from 'yup';

export const createKnowledgeBaseSchema = Yup.object().shape({
  name: Yup.string().trim().required('Knowledge base name is required'),
  kb_description: Yup.string().trim().required('Knowledge base description is required'),
});

export type CreateKnowledgeBaseFormValues = Yup.InferType<typeof createKnowledgeBaseSchema>;
